import { css } from "@emotion/react";
import FC_BARCELONA from "assets/fonts/Barca/FCBARCELONA-Regular-web.woff2";
import FC_BARCELONA_BOLD from "assets/fonts/Barca/FCBARCELONA-Bold-web.woff2";

const barcaStyles = css`
  @font-face {
    font-family: "FC Barcelona";
    src: local("FC Barcelona"), url(${FC_BARCELONA}) format("woff2");
  }

  @font-face {
    font-family: "FC Barcelona";
    src: local("FC Barcelona"), url(${FC_BARCELONA_BOLD}) format("woff2");
    font-weight: bold;
  }

  &.barca-games {
    body,
    .custom-page {
      background: linear-gradient(180deg, #581822 0%, #072f63 45%);
      font-family: "FC Barcelona", sans-serif;

      &.padd-sty {
        padding-top: 0;
      }
    }

    .navbar-home,
    .partner-status-bar,
    .footer-content {
      display: none !important;
    }

    .not-logo {
      padding-top: 1.25rem;
    }

    .title-md {
      color: #ffffff;
      font-family: Poppins;
      font-size: 1.3019rem;
      font-weight: 700;
      letter-spacing: 0.065rem;
      line-height: 0.6512rem;
    }

    .top-tournament-full-width {
      .top-tournaments-swiper {
        .timer-row,
        .participant-counter-row {
          height: 1rem;
          margin-top: 0.3125rem;

          svg {
            fill: none;
          }
        }

        .rank-btn {
          background-color: #378dd4;
        }

        .rank-btn,
        .text-play {
          border-radius: 0.25rem;
        }

        .game-details {
          color: #ffffff;
        }

        .swiper-pagination-bullets {
          bottom: -2rem !important;

          .swiper-pagination-bullet {
            background: #fff7e1;
            opacity: 1;
          }

          .swiper-pagination-bullet-active {
            background: #fd343d;
          }
        }
      }
    }

    .modal_header,
    .leaderboard-wrapper {
      background-color: #154284;
    }

    .modal_header {
      box-shadow: 0 0.125rem 0.5rem 0 rgba(0, 0, 0, 0.5);
    }

    .gamename-style {
      color: #ffffff !important;
    }

    .gamename-style {
      font-family: "FC Barcelona", sans-serif;
    }

    .prizes-slider-container {
      border-radius: 0.25rem;

      .prizes-slider-item {
        color: #ffffff;

        .title-xs {
          font-size: 0.75rem;
          font-weight: bold;
        }

        .icon {
          background: #cf122d;

          svg {
            fill: #ffffff;
          }
        }
      }
    }

    .half-style {
      border-radius: 0 0 0.25rem 0.25rem;
      margin-bottom: 0 !important;

      .latest-score-container {
        span {
          color: #fdc52c;
        }

        .latest-score-label {
          font-weight: bold;
        }
      }

      .player-rank-board {
        .first-board,
        .last-board {
          display: flex;
          flex-direction: column-reverse;
        }

        .label-style {
          background-color: #a3061c;
        }

        .name-style,
        .score {
          color: #ffffff;

          @media (width < 25.625rem) {
            font-size: 0.75rem;
          }
        }
      }
    }

    .second-half {
      .replay-button {
        display: none;
      }

      .button-bar {
        margin-bottom: 0;

        button {
          .btn-container {
            background: linear-gradient(90deg, #8c1a17 0%, #cd122d 100%);
            border: none;
            border-radius: 0.3125rem;
            box-shadow: none;
            margin-bottom: 0;
            transition: scale 0.3s;

            svg {
              color: #ffffff;
              width: 80%;
            }
          }

          &:hover {
            .btn-container {
              scale: 1.05;
            }
          }

          &:active {
            .btn-container {
              scale: 0.95;
            }
          }
        }
      }
    }

    .mission-page-container {
      padding-top: 1.25rem;

      .progressbar_wrapper {
        .circle_content {
          .helper_text {
            color: #ffffff;
          }
        }
      }

      .progress_bottom_curve {
        .clock_icon {
          fill: #ffffff;
        }
      }
    }

    .game-loading-overlay {
      background: linear-gradient(180deg, #581822 0%, #072f63 45%);

      .progress-bar-container {
        .progress-bar {
          opacity: 1;
        }
      }
    }

    .browse-games {
      .header-container {
        .title {
          color: #ffffff;
          font-family: Poppins;
          font-size: 1.3019rem;
          font-weight: 700;
          letter-spacing: 0.065rem;
          line-height: 0.6512rem;
        }
      }

      .browse-games-container {
        gap: 1.25rem;
        padding: 0 0.5rem;

        .text-center {
          display: none;
        }

        .col-6 {
          flex: 1 1 25%;
          width: auto;
        }
      }
    }

    .browse-game-card {
      .game-info {
        border-radius: 0.875rem;
        height: 6.5rem;
        width: 6.5rem;

        .image-style {
          border-radius: 0.875rem;
          height: 100%;
          object-fit: fill;
          width: 100%;
        }

        .info-container {
          padding: 0 !important;

          .game-name {
            height: 1.781rem;
          }

          .player-numb {
            .arcade-icon {
              fill: #ffffff !important;
            }
          }

          .triangle-div {
            top: unset;
            right: 0rem;
            bottom: 0.25rem;

            @media (width < 25.625rem) {
              bottom: 0.5rem;
              top: auto;
            }

            .triangle-button {
              border-radius: 0.375rem;
              padding: 0 !important;

              @media (width < 25.625rem) {
                height: 1.5625rem;
                width: 3.125rem;
              }

              .icon-play {
                fill: #ffffff;
                width: 0.75rem;
                height: 0.75rem;
              }
            }
          }
        }

        .triangle-bg {
          display: none;
        }
      }
    }

    .recommended-games {
      border-radius: 0.25rem;
      padding-top: 1.875rem !important;

      .header-style {
        padding-left: 1rem !important;
      }

      .games-container {
        gap: 1rem;

        .browse-game-card {
          width: fit-content;

          .game-info {
            border-radius: 0.875rem;
            height: 6.5rem;
            width: 6.5rem;

            .image-style {
              border-radius: 0.875rem;
              height: 100%;
              object-fit: fill;
              width: 100%;
            }

            .info-container {
              display: none;
            }

            .play-button {
              align-items: center;
              background: linear-gradient(90deg, #8c1a17 0%, #cd122d 100%);
              border-radius: 50%;
              border: none;
              bottom: 0.3125rem;
              color: #ffffff;
              display: flex;
              height: 1.5rem;
              justify-content: center;
              position: absolute;
              right: 0.3125rem;
              width: 1.5rem;
            }
          }
        }
      }
    }

    .rank-list-container-first,
    .rank-list-container {
      .list-group-item {
        &:first-child {
          border-radius: 0.25rem 0.25rem 0 0 !important;
        }

        &:last-child {
          border-radius: 0 0 0.25rem 0.25rem !important;
        }

        .text-style-transaction {
          color: #ffffff;
          font-size: 0.75rem;
          font-weight: bold;
        }
      }
    }

    .desktop-play-button-backward {
      background-color: #021d46;
      bottom: 10%;
      padding: 1rem 1rem 2.5rem 1rem;

      .motion-button {
        width: 100% !important;

        .desktop-play-footer {
          background: linear-gradient(270deg, rgb(140, 26, 23) 0%, rgb(205, 18, 45) 122.67%);
          border-radius: 0.3125rem;
          color: #ffffff !important;
          font-family: "FC Barcelona", sans-serif;
          font-size: 0.875rem;
          font-weight: bold;
          text-transform: uppercase;

          &:hover {
            background: #fd343d !important;
          }

          &:active {
            background: #a3061c !important;
          }
        }
      }
    }

    .leaderboard-container {
      color: #ffffff;

      .title-md {
        color: #ffffff;
      }

      .small-card {
        border-radius: 0.25rem;

        .button-alignment {
          .rank-btn,
          .play-btn-browse {
            background: linear-gradient(90deg, #8c1a17 0%, #cd122d 100%);
            border-radius: 0.3125rem;
            color: #ffffff;
            transition: scale 0.3s;

            &:hover {
              scale: 1.05;
            }

            &:active {
              scale: 0.95;
            }

            svg {
              height: 1.5rem !important;
              width: 1.5rem !important;
            }
          }
        }

        .btn-mob {
          background: linear-gradient(90deg, #8c1a17 0%, #cd122d 100%);
          border-radius: 0.25rem;
          border: none;
          color: #ffffff;
          font-family: "FC Barcelona", sans-serif;
          font-size: 0.875rem;
          margin-right: 1rem;
          padding: 0.5rem 1rem;
        }
      }
    }

    [data-rsbs-overlay] {
      background: transparent;
    }

    [data-rsbs-scroll] {
      border-radius: 0.25rem 0.25rem 0 0 !important;
    }

    .close_wrapper {
      .close {
        fill: #ffffff;
      }
    }

    .loading-style {
      display: none;
    }

    .btn-tap-to-see {
      button {
        border-radius: 0.3125rem;
        color: #ffffff !important;
      }
    }

    .subtitle {
      color: #ffffff;
    }

    .footer-wrapper {
      .font-style {
        color: #ffffff;
      }
    }

    .browse-game-list {
      .header-container {
        .title {
          padding-left: 0.5rem !important;
        }
      }

      .row {
        .browse-games-rectangular-card {
          align-items: center;
          background: linear-gradient(180deg, #154284 60%, #181833 100%);
          border-radius: 0.875rem;
          height: fit-content;
          min-height: 10.5rem;
          width: 7.8125rem;

          .browse-games-rectangular-card-top {
            img {
              border-radius: 0.875rem;
              height: 6.1875rem;
              width: 5.125rem;
            }
          }

          .browse-games-rectangular-card-bottom {
            .game-name {
              font-family: Poppins;
              font-size: 0.75rem;
              font-weight: 700;
              letter-spacing: 1%;
              line-height: 1.0637rem;
            }

            .participant-counter-row {
              margin: 0;

              .count {
                color: #fdc42c !important;
                font-family: Poppins;
                font-size: 0.625rem;
                font-weight: 400;
                letter-spacing: 1%;
                line-height: 0.8862rem;
              }
            }
          }
        }
      }
    }

    .prize-list-container {
      border-radius: 0.25rem;
    }

    .browse-popup {
      border-radius: 0.25rem;

      .img-style {
        border: none;
      }

      .gamename-style {
        color: #fdc52c !important;
      }
    }

    .arcade-game-page {
      display: none;
    }

    .arcade-game {
      padding-top: 1.5rem;

      .arcade-headerSty2,
      .trending-game,
      .arcade-all-game,
      .search-results-title {
        color: #ffffff;
      }

      .search-bar {
        input {
          border-radius: 0.25rem;
        }

        .search-button {
          background: linear-gradient(90deg, #8c1a17 0%, #cd122d 100%);
          border-radius: 0 0.25rem 0.25rem 0;
          color: #ffffff;
        }
      }

      .slider-container {
        .swiper-button-prev,
        .swiper-button-next {
          color: #fdc52c;
        }
      }

      .category-link-card,
      .img-fluid,
      .react-select__control,
      .game-card,
      .game-title {
        border-radius: 0.25rem;
      }

      .btn-load-more {
        background: linear-gradient(90deg, #8c1a17 0%, #cd122d 100%);
        border-radius: 0.3125rem;
      }

      .face {
        border-color: #cd122d;

        .dot {
          background-color: #cd122d;
        }
      }

      .error-container {
        .error-image {
          svg {
            fill: #cd122d;
          }
        }

        .back-to-home {
          color: #cd122d;
        }
      }

      .react-select__menu {
        background: #072f63;
        border-radius: 0.25rem;
        color: #ffffff;

        .react-select__option {
          &:hover {
            background-color: #154284;
            color: #fdc52c;
          }
        }

        .react-select__option--is-focused {
          background-color: transparent;
          color: inherit;
        }

        .react-select__option--is-selected {
          background-color: #154284;
          color: #fdc52c;
        }
      }
    }

    .pvp-card-container {
      .card-style {
        border-radius: 0.25rem;

        .img-sty {
          .thumbnail {
            border-radius: 0.25rem;
          }
        }
      }

      .red-button {
        background: linear-gradient(90deg, #8c1a17 0%, #cd122d 100%);
        border-radius: 0.3125rem;
        color: #ffffff;
      }
    }

    .modal-content {
      border-radius: 0.25rem;

      .body-style {
        .text-style {
          color: #000000;
        }
      }

      .modal-footer {
        button {
          border-radius: 0.3125rem;
        }
      }
    }

    .loader-wrapper {
      padding: 0 !important;
    }

    .top-battles-container {
      padding: 0 !important;
      margin: 0.5rem !important;

      .top-battles-card {
        background: linear-gradient(180deg, #154284 60%, #181833 100%);
        border-radius: 0.875rem;
        box-shadow: 0rem 0.375rem 0.3125rem 0rem #92c4e966;
        height: 16.25rem;
        padding: 0 !important;
        width: 10.0625rem;

        .frame {
          display: none;
        }

        .img {
          height: 11.375rem !important;
          position: relative;
          top: unset;
          width: 10.0625rem !important;

          .img-style {
            border-radius: 0.875rem 0.875rem 0 0;
            height: 100%;
            object-fit: fill;
            padding: 0 !important;
            width: 100%;
          }
        }

        .goama-font {
          align-items: center;
          border-radius: 0 0 0.875rem 0.875rem;
          bottom: unset;
          display: flex !important;
          height: 4.875rem;
          justify-content: center !important;
          position: relative;
          width: 10.0625rem;

          .game-name {
            color: #ffffff;
            font-family: Poppins;
            font-size: 0.875rem;
            font-weight: 700;
            letter-spacing: 0.065rem;
            line-height: 0.6512rem;
            max-width: none;
          }
        }
      }
    }

    .mobile-footer-page-wrapper {
      display: flex;
      flex-direction: column-reverse;
      gap: 2rem;
    }
  }
`;

export default barcaStyles;
